export default function getItemizedMonthlyPayments(_ref) {
  var monthlyMortgagePayment = _ref.monthlyMortgagePayment,
      yearlyPropertyTax = _ref.yearlyPropertyTax,
      monthlyHomeownersInsurance = _ref.monthlyHomeownersInsurance,
      monthlyHoaDues = _ref.monthlyHoaDues,
      mortgageInsurancePayment = _ref.mortgageInsurancePayment;
  return {
    total: monthlyMortgagePayment + yearlyPropertyTax / 12 + monthlyHomeownersInsurance + monthlyHoaDues + mortgageInsurancePayment,
    mortgage: monthlyMortgagePayment,
    taxesAndFees: yearlyPropertyTax / 12 + monthlyHoaDues + monthlyHomeownersInsurance,
    propertyTax: yearlyPropertyTax / 12,
    homeownersInsurance: monthlyHomeownersInsurance,
    hoa: monthlyHoaDues,
    mortgageInsurancePayment: mortgageInsurancePayment
  };
}